'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.factory('alertsiteService', function($q, apiEndpointFactory) {

  return {
    optOut: function() {
      var endpoint = apiEndpointFactory.new({
        endpointUrl: '/alertsite-opt-out',
        allowedMethods: ['get']
      });

      return endpoint.get().then(function(response) {
        return response.data;
      }, function(response) {
        return $q.reject(response.status);
      });
    }
  };
});
